import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1 q-mt-none justify-be" }, "Date Range", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1" }, "Social Sites", -1)
const _hoisted_3 = { class: "q-mt-md text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_date_range = _resolveComponent("select-date-range")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_select_site = _resolveComponent("select-site")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_total_posts = _resolveComponent("total-posts")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Create Album",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Create",
        color: "primary",
        task: _ctx.task,
        disabled: !_ctx.canCreate,
        onClick: _ctx.create
      }, null, 8, ["task", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_select_date_range, {
        modelValue: _ctx.dateRange,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_separator, { class: "q-mt-md" }),
      _hoisted_2,
      _createVNode(_component_select_site, {
        modelValue: _ctx.socialSiteIds,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.socialSiteIds) = $event)),
        onLoaded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.socialSites.selectAll())),
        ref: "socialSites"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_separator, { class: "q-my-md" }),
      _createVNode(_component_q_input, {
        label: "Album Name",
        modelValue: _ctx.name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.name) = $event)),
        outlined: ""
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_total_posts, { filters: _ctx.postFilters }, {
          default: _withCtx(({ isLoading, total }) => [
            _createTextVNode(" This album will contain "),
            _withDirectives(_createElementVNode("strong", null, _toDisplayString(total), 513), [
              [_vShow, !isLoading]
            ])
          ]),
          _: 1
        }, 8, ["filters"])
      ])
    ]),
    _: 1
  }, 512))
}